import { render, staticRenderFns } from "./ConventionTitle.vue?vue&type=template&id=925930c2"
import script from "./ConventionTitle.vue?vue&type=script&lang=js"
export * from "./ConventionTitle.vue?vue&type=script&lang=js"
import style0 from "./ConventionTitle.vue?vue&type=style&index=0&id=925930c2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports